import { z } from 'zod';
import { ShopItemType } from 'store/shop';
import { adminContentReviewsFiltersSchema } from './admin-content-reviews.schemas';

export const contentReviewEntityTypes = [
  'service',
  'discount',
  'pointOfSale',
  'company',
] as const;
export type ContentReviewEntityType = (typeof contentReviewEntityTypes)[number];

export const contentReviewStatuses = [
  'pending',
  'approved',
  'rejected',
] as const;
export type ContentReviewStatus = (typeof contentReviewStatuses)[number];

export const contentReviewFieldKinds = [
  'text',
  'image',
  'json',
  'group',
] as const;
export type ContentReviewFieldKind = (typeof contentReviewFieldKinds)[number];

export const contentReviewEntityTypeLabels: Record<
  ContentReviewEntityType,
  string
> = {
  service: 'Service',
  discount: 'Discount',
  pointOfSale: 'Location',
  company: 'Company',
};

export interface ContentReviewSupplier {
  id: string;
  name: string;
}

export interface ContentReviewListItem {
  id: string;
  entityType: ContentReviewEntityType;
  liveEntityId: string;
  entityName: string;
  itemType?: ShopItemType | null;
  supplier: ContentReviewSupplier;
  status: ContentReviewStatus;
  submittedAt: string;
  submittedByName: string | null;
}

export interface ContentReviewField {
  key: string;
  label: string;
  kind: ContentReviewFieldKind;
  live: string | null;
  proposed: string | null;
  changed: boolean;
  children?: ContentReviewField[];
}

export interface ContentReviewDetails {
  id: string;
  entityType: ContentReviewEntityType;
  liveEntityId: string;
  entityName: string;
  itemType?: ShopItemType | null;
  supplier: ContentReviewSupplier;
  status: ContentReviewStatus;
  submittedAt: string;
  submittedByName: string | null;
  reviewedAt: string | null;
  reviewedByName: string | null;
  rejectReason: string | null;
  hasConflict: boolean;
  fields: ContentReviewField[];
}

export type AdminContentReviewsFilters = z.infer<
  typeof adminContentReviewsFiltersSchema
>;
